export const ActionTypes = {
  SET_LOADER: "settingLoderValue",
};

export const setLoader = (flag) => ({
  type: ActionTypes.SET_LOADER,
  payload: flag,
});
